import { useTheme } from '../lib/theme-context.js';
import type { Theme } from '../lib/theme-context.js';

const NEXT: Record<Theme, Theme> = { system: 'light', light: 'dark', dark: 'system' };
const ICON: Record<Theme, string> = {
  system: 'bx-desktop',
  light: 'bx-sun',
  dark: 'bx-moon',
};
const NAME: Record<Theme, string> = {
  system: 'Theme: follows your system. Activate for light.',
  light: 'Theme: light. Activate for dark.',
  dark: 'Theme: dark. Activate to follow your system.',
};

/**
 * Spec 229 — the control spec 228 built the context for but could not place,
 * because the bar it belongs in did not exist yet.
 *
 * Icon-only, so it carries a real accessible name describing the CURRENT state
 * and what activating it does — never a title tooltip as its only name. The
 * icon alone cannot say "system", which is why the name is a sentence.
 */
export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  return (
    <button
      type="button"
      className="hub-round"
      aria-label={NAME[theme]}
      data-testid="theme-toggle"
      data-theme-state={theme}
      onClick={() => setTheme(NEXT[theme])}
    >
      <i className={`bx ${ICON[theme]}`} aria-hidden="true" />
    </button>
  );
}
